import React, { useContext } from "react"
import { I18nextContext, Link } from "gatsby-plugin-react-i18next"

const translation = {
  en: {
    header: `Contact me`,
  },
  fi: {
    header: `Ota yhteyttä`,
  },
}

const ContactButton = () => {
  const { language } = useContext(I18nextContext)
  return (
    <>
      <Link to="/contacts">
        <button
          type="button"
          aria-label="contact-me"
          className="btn btn-red focus:outline-none min-w-full sm:min-w-0"
        >
          {translation[language].header}
        </button>
      </Link>
    </>
  )
}

export default ContactButton
